import { StateCreator } from 'zustand';
import { DevtoolsOptions, PersistOptions, devtools, persist } from 'zustand/middleware';

/**
 * 
 * @param callback is the function that creates the state
 * @param storeConfig is an object that defines the options to use for store creation
 * @param devtoolsOptions is an object to define the devtool options
 * @returns middileware
 */
export const visionMiddileware = (callback: StateCreator<any>, storeConfig: PersistOptions<any, any>, devtoolsOptions: DevtoolsOptions = {}) => devtools(persist(callback, storeConfig), {
    ...devtoolsOptions,
    enabled: process.env.NODE_ENV === 'development' // enabling only for dev environment
})